import { sortBy } from 'lodash';
import { theme } from '../../../theme';
import { LineStatus } from '../../../redux/tickets/types/kds-line/status';
import { KdsLine } from '../../../redux/tickets/types/kds-line';
import { KdsTicket } from '../../../redux/tickets/types/ticket';
import { getTerminalStatus } from '../../../redux/tickets/selectorLibs/filterActiveTicketByChildrenStatus';

export const getFormulaHeaderFontColor = (status: LineStatus): string => {
    switch (status) {
        case LineStatus.Doing:
            return theme.color.white;
        case LineStatus.Done:
            return theme.color.blackGrey;

        default:
            return theme.color.black;
    }
};

export const lineHasChild = (kdsLine: KdsLine): boolean => Object.keys(kdsLine.kdsLines ?? {}).length > 0;

export const sortLinesByIndex = <T extends { index?: number }>(lines: T[]): T[] =>
    lines.length && lines[0].index !== undefined ? sortBy(lines, 'index') : sortBy(lines, 'uuid');

export const sortLinesByName = <T extends { name?: string }>(lines: T[]): T[] =>
    lines.length && lines[0].name !== undefined ? sortBy(lines, 'name') : sortBy(lines, 'uuid');

const startedState = [LineStatus.Doing, LineStatus.Done, LineStatus.ToAssemble, LineStatus.Delivered];

const getLinesStatus = (lines: KdsLine[], isProductFollowUpEnabled: boolean): LineStatus[] =>
    lines.map((line) =>
        lineHasChild(line) ? computeFormulaStatus(Object.values(line.kdsLines), isProductFollowUpEnabled) : line.status,
    );

export const computeFormulaStatus = (lines: KdsLine[], isProductFollowUpEnabled = false): LineStatus => {
    const terminalState = getTerminalStatus(isProductFollowUpEnabled);

    switch (true) {
        case getLinesStatus(lines, isProductFollowUpEnabled).every((status) => terminalState.includes(status)):
            return isProductFollowUpEnabled ? LineStatus.Delivered : LineStatus.Done;

        case getLinesStatus(lines, isProductFollowUpEnabled).some((status) => startedState.includes(status)):
            return LineStatus.Doing;

        default:
            return LineStatus.ToDo;
    }
};

export const isOrderPaid = (orderStatus: KdsTicket['orderStatus']) =>
    !orderStatus || !['ORDERED', 'VALIDATED'].includes(orderStatus);
